module.exports = __webpack_public_path__ + "img/tb-9.92705808.png";